module.exports = __webpack_public_path__ + "img/logo8.92b17843.png";